/* Greenleaf — the Back to top arrow. 11 Oct 2026, round-2 audit (Andrew's yes): a small round arrow in the page's own
 * colours, drawn hidden by layout/theme.liquid on every long page, shown only after about two screens of scrolling.
 *
 * It must never sit on something the shopper needs, so it steps aside (class is-covered) while
 *   - a computer menu panel (.mega) or the phone menu (#gl-mmenu) is open,
 *   - the phone filter sheet is open (the #gl-filters :target),
 *   - or it would overlap any button, text link made a button, form field or the cookie banner in view
 *     (the closing band's buttons are the case the audit named).
 * Without this file the arrow stays hidden and nothing breaks.
 */
(function () {
  'use strict';
  var bt = document.querySelector('[data-bt-top]');
  if (!bt) return;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var COVER = '.btn, .textlink--cta, main button, main input, main select, main textarea, footer a, #shopify-pc__banner';
  var queued = false;

  function overlaps(a, b, pad) {
    return !(a.right < b.left - pad || a.left > b.right + pad || a.bottom < b.top - pad || a.top > b.bottom + pad);
  }
  function menuOpen() {
    if (document.querySelector('.mega:not([hidden])')) return true;
    var m = document.getElementById('gl-mmenu');
    if (m && !m.hidden) return true;
    var f = document.getElementById('gl-filters');
    return !!(f && f.matches(':target'));
  }
  function covered() {
    if (menuOpen()) return true;
    var r = bt.getBoundingClientRect();
    var els = document.querySelectorAll(COVER);
    for (var i = 0; i < els.length; i++) {
      var e = els[i];
      if (e === bt) continue;
      var q = e.getBoundingClientRect();
      if (q.width && q.height && q.bottom > 0 && q.top < window.innerHeight && overlaps(r, q, 10)) return true;
    }
    return false;
  }
  function update() {
    queued = false;
    var want = window.pageYOffset > Math.max(1400, window.innerHeight * 1.6);
    if (bt.hidden === want) bt.hidden = !want;
    if (want) bt.classList.toggle('is-covered', covered());
  }
  function queue() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(update);
  }
  window.addEventListener('scroll', queue, { passive: true });
  window.addEventListener('resize', queue);
  document.addEventListener('click', function () { window.setTimeout(queue, 60); });
  window.addEventListener('hashchange', queue);
  update();
  bt.addEventListener('click', function () {
    window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
    var t = document.querySelector('h1');
    if (t) { t.setAttribute('tabindex', '-1'); t.focus({ preventScroll: true }); }
  });
})();
